import React from 'react'
import { connect } from 'react-redux'
import { Page404 } from '../src/ui'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import config from '../src/config/config.json'

class NotFoundPage extends React.Component {
  static async getInitialProps ({store}) {
    return {
      title: config.pages.notFoundTitle,
      isPageExists: false,
      state: NotFoundPage.getPageState(store)
    }
  }

  static getPageState (store) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = true
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups.elements = currentState.groups.elements

      state.categories.elements = currentState.categories.elements
      state.categories.bySeo = currentState.categories.bySeo

      state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
      state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas

      state.form = currentState.form
    }
    return state
  }

  render () {
    return <Page404 />
  }
}

export default NotFoundPage
